import { Icon } from './chunk-KWL4QMKO.js';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

function createIcon(src16, src24, src32, displayName) {
  const iconComponent = forwardRef(
    (props, ref) => /* @__PURE__ */ jsx(
      Icon,
      {
        ...props,
        ref,
        src16,
        src24,
        src32
      }
    )
  );
  iconComponent.displayName = displayName;
  iconComponent["__slot__"] = "icon";
  return iconComponent;
}

export { createIcon };
